import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import CornerDownIcon from '../../../../assets/icons/tutorialBgCornerDown.svg';
import CornerTopIcon from '../../../../assets/icons/tutorialBgCornerTop.svg';

const CORNER_SIZE = 10;

function TutorialBackground({
  x, y, width, height, isInteractive,
}) {
  return (
    <div className={styles.tutorialBackground}>
      {!isInteractive && (
        <div className={styles.tutorialBackgroundBlockingOverlay} />
      )}

      {/* Items Start (Corners are inside left and right panels) */}
      <div
        className={styles.tutorialBackgroundItem}
        style={{
          left: 0, top: 0, width: '100vw', height: `${y + 1}px`,
        }}
      />
      <div
        className={styles.tutorialBackgroundItem}
        style={{
          left: `${x + width}px`, top: `${y}px`, width: `calc(100vw - ${x + width}px)`, height: `${height + 1}px`,
        }}
      >
        {/* Corners Start */}
        <div
          style={{ left: `${-CORNER_SIZE + 1}px`, top: `${-1}px` }}
          className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerTopRight)}
        >
          <img src={CornerDownIcon} alt="" />
        </div>
        <div
          style={{ left: `${-CORNER_SIZE + 1}px`, top: `${height - CORNER_SIZE + 1}px` }}
          className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerBottomRight)}
        >
          <img src={CornerTopIcon} alt="" />
        </div>
        {/* Corners End */}
      </div>
      <div
        className={styles.tutorialBackgroundItem}
        style={{
          left: 0, top: `${y + height}px`, width: '100vw', height: `calc(100vh - ${y + height}px)`,
        }}
      />
      <div
        className={styles.tutorialBackgroundItem}
        style={{
          left: 0, top: `${y}px`, width: `${x}px`, height: `${height + 1}px`, transform: 'rotate(180deg)',
        }}
      >
        {/* Corners Start */}
        <div
          // style={{ left: `${x - 1}px`, top: '0px' }}
          style={{ left: `${-CORNER_SIZE + 1}px`, top: `${-2}px` }}
          className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerTopLeft)}
        >
          <img src={CornerDownIcon} alt="" />
        </div>
        <div
          // style={{ left: `${x - 1}px`, top: `${height - CORNER_SIZE + 1}px` }}
          style={{ left: `${-CORNER_SIZE + 1}px`, top: `${height - CORNER_SIZE + 1}px` }}
          className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerBottomLeft)}
        >
          <img src={CornerTopIcon} alt="" />
        </div>
        {/* Corners End */}
      </div>
      {/* Items End */}

      {/* Corners Start */}
      {/* <div
        style={{ left: `${x - 1}px`, top: `${y - 1}px` }}
        className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerTopLeft)}
      >
        <img src={CornerIcon} alt="" />
      </div>
      <div
        style={{ left: `${(x + width - CORNER_SIZE) + 3}px`, top: `${y - 1}px` }}
        className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerTopRight)}
      >
        <img src={CornerIcon} alt="" />
      </div>
      <div
        style={{ left: `${(x + width - CORNER_SIZE) + 3}px`, top: `${(y + height - CORNER_SIZE) + 3}px` }}
        className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerBottomRight)}
      >
        <img src={CornerIcon} alt="" />
      </div>
      <div
        style={{ left: `${x - 3}px`, top: `${(y + height - CORNER_SIZE) + 3}px` }}
        className={classNames(styles.tutorialBackgroundCorner, styles.tutorialBackgroundCornerBottomLeft)}
      >
        <img src={CornerIcon} alt="" />
      </div> */}
      {/* Corners End */}
    </div>
  );
}

export default TutorialBackground;
